import React, { useState, useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { useNavigate } from 'react-router-dom';


// Define SVG markers with different colors and classes
const greenSvgMarkerEEZ = `
  <svg class="iconGreen" viewBox="0 0 17.008 42.52" xmlns="http://www.w3.org/2000/svg">
    <defs><style>.b { fill: green }</style></defs>
    <polygon style="fill: green" points="

17.008 42.52 8.504 36.849 0 42.52 0 19.842 7.775 0 9.233 0 17.008 19.842 17.008 42.52"/>
    <path d="M9.254,.054v-.054h-1.5V.054L0,19.842v22.678l8.504-5.67,8.504,5.67V19.842L9.254,.054Zm-.083,19.789c0,.368-.299,.667-.667,.667s-.667-.299-.667-.667,.299-.668,.667-.668,.667,.3,.667,.668Zm6.336,19.874l-6.172-4.115-.832-.555-.832,.555-6.172,4.115V20.125L7.754,4.165v13.651c-.825,.307-1.417,1.096-1.417,2.026,0,1.195,.972,2.167,2.167,2.167s2.167-.972,2.167-2.167c0-.931-.592-1.719-1.417-2.026V4.165l6.254,15.96v19.591Z"/>
  </svg>`;

  
const orangeSvgMarkerEEZ = `
  <svg class="iconOrange" viewBox="0 0 17.008 42.52" xmlns="http://www.w3.org/2000/svg">
    <defs><style>.b { fill: orange }</style></defs>
    <polygon style="fill: orange" points="17.008 42.52 8.504 36.849 0 42.52 0 19.842 7.775 0 9.233 0 17.008 19.842 17.008 42.52"/>
     <path d="M9.254,.054v-.054h-1.5V.054L0,19.842v22.678l8.504-5.67,8.504,5.67V19.842L9.254,.054Zm-.083,19.789c0,.368-.299,.667-.667,.667s-.667-.299-.667-.667,.299-.668,.667-.668,.667,.3,.667,.668Zm6.336,19.874l-6.172-4.115-.832-.555-.832,.555-6.172,4.115V20.125L7.754,4.165v13.651c-.825,.307-1.417,1.096-1.417,2.026,0,1.195,.972,2.167,2.167,2.167s2.167-.972,2.167-2.167c0-.931-.592-1.719-1.417-2.026V4.165l6.254,15.96v19.591Z"/>
  </svg>`;
const redSvgMarkerEEZ = `
  <svg class="iconRed" viewBox="0 0 17.008 42.52" xmlns="http://www.w3.org/2000/svg">
    <defs><style>.b { fill: red }</style></defs>
    <polygon style="fill: red" points="17.008 42.52 8.504 36.849 0 42.52 0 19.842 7.775 0 9.233 0 17.008 19.842 17.008 42.52"/>
    <path d="M9.254,.054v-.054h-1.5V.054L0,19.842v22.678l8.504-5.67,8.504,5.67V19.842L9.254,.054Zm-.083,19.789c0,.368-.299,.667-.667,.667s-.667-.299-.667-.667,.299-.668,.667-.668,.667,.3,.667,.668Zm6.336,19.874l-6.172-4.115-.832-.555-.832,.555-6.172,4.115V20.125L7.754,4.165v13.651c-.825,.307-1.417,1.096-1.417,2.026,0,1.195,.972,2.167,2.167,2.167s2.167-.972,2.167-2.167c0-.931-.592-1.719-1.417-2.026V4.165l6.254,15.96v19.591Z"/>
  </svg>`;
const graySvgMarkerEEZ = `
  <svg class="iconGray" viewBox="0 0 17.008 42.52" xmlns="http://www.w3.org/2000/svg">
    <defs><style>.b { fill: gray }</style></defs>
    <polygon style="fill: gray" points="17.008 42.52 8.504 36.849 0 42.52 0 19.842 7.775 0 9.233 0 17.008 19.842 17.008 42.52"/>
    <path d="M9.254,.054v-.054h-1.5V.054L0,19.842v22.678l8.504-5.67,8.504,5.67V19.842L9.254,.054Zm-.083,19.789c0,.368-.299,.667-.667,.667s-.667-.299-.667-.667,.299-.668,.667-.668,.667,.3,.667,.668Zm6.336,19.874l-6.172-4.115-.832-.555-.832,.555-6.172,4.115V20.125L7.754,4.165v13.651c-.825,.307-1.417,1.096-1.417,2.026,0,1.195,.972,2.167,2.167,2.167s2.167-.972,2.167-2.167c0-.931-.592-1.719-1.417-2.026V4.165l6.254,15.96v19.591Z"/>
  </svg>`;



  const greenSvgMarker = `
<svg xmlns="http://www.w3.org/2000/svg" version="1.2" viewBox="0 0 1080 1920" width="338" height="600">
	<title>New Project</title>
	<defs>
		<image width="1080" height="1920" id="img1" href="data:image/png;base64,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"/>
	</defs>
	<style>
		.s0 { display: none;fill: #000000 } 
		.s1 { fill:green;stroke: #000000;paint-order:stroke fill markers;stroke-linejoin: round;stroke-width: 180 } 
	</style>
	<use id="Background" style="display: none" href="#img1" x="0" y="0"/>
	<path id="Shape 1" fill-rule="evenodd" class="s0" d="m1080.3 986.7h-1094.3l547.2-947.7z"/>
	<path id="Shape 1 copy 2" fill-rule="evenodd" class="s0" d="m1080.3 986.7h-1094.3l547.2-947.7z"/>
	<path id="Shape 1 copy" class="s1" d="m1032 1668h-978.4l489.2-1424.5zm-3.7-691.8h-983.3l491.7-895.2z"/>
</svg>
`;

const orangeSvgMarker = `
<svg xmlns="http://www.w3.org/2000/svg" version="1.2" viewBox="0 0 1080 1920" width="338" height="600">
	<title>New Project</title>
	<defs>
		<image width="1080" height="1920" id="img1" href="data:image/png;base64,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"/>
	</defs>
	<style>
		.s0 { display: none;fill: #000000 } 
		.s1 { fill:orange; stroke: #000000;paint-order:stroke fill markers;stroke-linejoin: round;stroke-width: 102 } 
	</style>
	<use id="Background" style="display: none" href="#img1" x="0" y="0"/>
	<path id="Shape 1" fill-rule="evenodd" class="s0" d="m1080.3 986.7h-1094.3l547.2-947.7z"/>
	<path id="Shape 1 copy 2" fill-rule="evenodd" class="s0" d="m1080.3 986.7h-1094.3l547.2-947.7z"/>
	<path id="Shape 1 copy" class="s1" d="m1032 1668h-978.4l489.2-1424.5zm-3.7-691.8h-983.3l491.7-895.2z"/>
</svg>
`;

const redSvgMarker= `
<svg xmlns="http://www.w3.org/2000/svg" version="1.2" viewBox="0 0 1080 1920" width="338" height="600">
	<title>New Project</title>
	<defs>
		<image width="1080" height="1920" id="img1" href="data:image/png;base64,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"/>
	</defs>
	<style>
		.s0 { display: none;fill: #000000 } 
		.s1 { fill:red; stroke: #000000;paint-order:stroke fill markers;stroke-linejoin: round;stroke-width: 102 } 
	</style>
	<use id="Background" style="display: none" href="#img1" x="0" y="0"/>
	<path id="Shape 1" fill-rule="evenodd" class="s0" d="m1080.3 986.7h-1094.3l547.2-947.7z"/>
	<path id="Shape 1 copy 2" fill-rule="evenodd" class="s0" d="m1080.3 986.7h-1094.3l547.2-947.7z"/>
	<path id="Shape 1 copy" class="s1" d="m1032 1668h-978.4l489.2-1424.5zm-3.7-691.8h-983.3l491.7-895.2z"/>
</svg>
`;

const graySvgMarker = `
<svg xmlns="http://www.w3.org/2000/svg" version="1.2" viewBox="0 0 1080 1920" width="338" height="600">
	<title>New Project</title>
	<defs>
		<image width="1080" height="1920" id="img1" href="data:image/png;base64,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"/>
	</defs>
	<style>
		.s0 { display: none;fill: #000000 } 
		.s1 { fill:gray; stroke: #000000;paint-order:stroke fill markers;stroke-linejoin: round;stroke-width: 102 } 
	</style>
	<use id="Background" style="display: none" href="#img1" x="0" y="0"/>
	<path id="Shape 1" fill-rule="evenodd" class="s0" d="m1080.3 986.7h-1094.3l547.2-947.7z"/>
	<path id="Shape 1 copy 2" fill-rule="evenodd" class="s0" d="m1080.3 986.7h-1094.3l547.2-947.7z"/>
	<path id="Shape 1 copy" class="s1" d="m1032 1668h-978.4l489.2-1424.5zm-3.7-691.8h-983.3l491.7-895.2z"/>
</svg>
`;

function MapPoints({ map, positions, onMarkerClick }) {
  const navigate = useNavigate();
  const isMounted = useRef(true);

  // Function to convert degrees to DMS format
  const toDMS = (deg, isLatitude) => {
    const absolute = Math.abs(deg);
    const degrees = Math.floor(absolute);
    const minutesNotTruncated = (absolute - degrees) * 60;
    const minutes = Math.floor(minutesNotTruncated);
    const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(2);
    const direction = isLatitude ? (deg >= 0 ? 'N' : 'S') : (deg >= 0 ? 'E' : 'W');
    return `${degrees}° ${minutes}' ${seconds}" ${direction}`;
  };

  useEffect(() => {
    // Set isMounted to true when component mounts
    isMounted.current = true;

    if (!map || !positions || !Array.isArray(positions) || positions.length === 0) {
      console.log('Missing requirements:', {
        map: !!map,
        positions,
        isArray: Array.isArray(positions),
      });
      return;
    }

    const addMapFeatures = () => {
      const now = Date.now();
      const fourHoursThirtyMin = 4.5 * 60 * 60 * 1000;
      const sixHours = 6 * 60 * 60 * 1000;
      const sevenDays = 7 * 24 * 60 * 60 * 1000;

      // Clean up existing layers and sources safely
      try {
        if (map?.getLayer?.('points')) {
          map.removeLayer('points');
        }
        if (map?.getSource?.('points')) {
          map.removeSource('points');
        }
      } catch (error) {
        console.warn('Error during initial cleanup:', error);
      }

      const geojson = {
        type: 'FeatureCollection',
        features: positions
          .map((position, index) => {
            if (!position.longitude || !position.latitude) {
              console.warn(`Invalid position at index ${index}:`, position);
              return null;
            }

            const createdGpsTime = new Date(position.createdGpsTime + 'Z').getTime();
            const timeDiff = now - createdGpsTime;
            const markerClass =
              timeDiff < fourHoursThirtyMin
                ? 'iconGreen'
                : timeDiff < sixHours
                ? 'iconOrange'
                : timeDiff < sevenDays
                ? 'iconRed'
                : 'iconGray';

            return {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [Number(position.longitude), Number(position.latitude)],
              },
              properties: {
                deviceId: position.deviceId || 'Unknown',
                vesselNumber: position.vesselNumber || 'Unknown',
                createdGpsTime: position.createdGpsTime || Date.now(),
                speed: position.speed || 0,
                status: position.status || 'N/A',
                eez: position.eez || 'N/A',
                bearing: position.bearing || 'N/A',
                symbol: position.symbol || 'N/A',
                timeDiff,
                markerClass,
              },
            };
          })
          .filter((feature) => feature),
      };

      try {
        // Remove existing source and layer if they exist
        if (map.getLayer('points')) map.removeLayer('points');
        if (map.getSource('points')) map.removeSource('points');

        map.addSource('points', {
          type: 'geojson',
          data: geojson,
        });

        const loadMarkerImages = () => {
          const greenImgEEZ = new Image(8, 21);
          const orangeImgEEZ = new Image(8, 21);
          const redImgEEZ = new Image(8, 21);
          const grayImgEEZ = new Image(8, 21);
          const greenImg = new Image(11, 25);
          const orangeImg = new Image(11, 25);
          const redImg = new Image(11, 25);
          const grayImg = new Image(11, 25);

          const greenBlobEEZ = new Blob([greenSvgMarkerEEZ], { type: 'image/svg+xml;charset=utf-8' });
          const orangeBlobEEZ = new Blob([orangeSvgMarkerEEZ], { type: 'image/svg+xml;charset=utf-8' });
          const redBlobEEZ = new Blob([redSvgMarkerEEZ], { type: 'image/svg+xml;charset=utf-8' });
          const grayBlobEEZ = new Blob([graySvgMarkerEEZ], { type: 'image/svg+xml;charset=utf-8' });
          const greenBlob = new Blob([greenSvgMarker], { type: 'image/svg+xml;charset=utf-8' });
          const orangeBlob = new Blob([orangeSvgMarker], { type: 'image/svg+xml;charset=utf-8' });
          const redBlob = new Blob([redSvgMarker], { type: 'image/svg+xml;charset=utf-8' });
          const grayBlob = new Blob([graySvgMarker], { type: 'image/svg+xml;charset=utf-8' });

          const greenUrlEEZ = URL.createObjectURL(greenBlobEEZ);
          const orangeUrlEEZ = URL.createObjectURL(orangeBlobEEZ);
          const redUrlEEZ = URL.createObjectURL(redBlobEEZ);
          const grayUrlEEZ = URL.createObjectURL(grayBlobEEZ);
          const greenUrl = URL.createObjectURL(greenBlob);
          const orangeUrl = URL.createObjectURL(orangeBlob);
          const redUrl = URL.createObjectURL(redBlob);
          const grayUrl = URL.createObjectURL(grayBlob);

          Promise.all([
            new Promise((resolve, reject) => {
              greenImgEEZ.onload = () => resolve('greenEEZ');
              greenImgEEZ.onerror = reject;
              greenImgEEZ.src = greenUrlEEZ;
            }),
            new Promise((resolve, reject) => {
              orangeImgEEZ.onload = () => resolve('orangeEEZ');
              orangeImgEEZ.onerror = reject;
              orangeImgEEZ.src = orangeUrlEEZ;
            }),
            new Promise((resolve, reject) => {
              redImgEEZ.onload = () => resolve('redEEZ');
              redImgEEZ.onerror = reject;
              redImgEEZ.src = redUrlEEZ;
            }),
            new Promise((resolve, reject) => {
              grayImgEEZ.onload = () => resolve('grayEEZ');
              grayImgEEZ.onerror = reject;
              grayImgEEZ.src = grayUrlEEZ;
            }),
            new Promise((resolve, reject) => {
              greenImg.onload = () => resolve('green');
              greenImg.onerror = reject;
              greenImg.src = greenUrl;
            }),
            new Promise((resolve, reject) => {
              orangeImg.onload = () => resolve('orange');
              orangeImg.onerror = reject;
              orangeImg.src = orangeUrl;
            }),
            new Promise((resolve, reject) => {
              redImg.onload = () => resolve('red');
              redImg.onerror = reject;
              redImg.src = redUrl;
            }),
            new Promise((resolve, reject) => {
              grayImg.onload = () => resolve('gray');
              grayImg.onerror = reject;
              grayImg.src = grayUrl;
            }),
          ])
            .then(() => {
              if (isMounted.current) {
                if (!map.hasImage('green-marker-eez')) map.addImage('green-marker-eez', greenImgEEZ);
                if (!map.hasImage('orange-marker-eez')) map.addImage('orange-marker-eez', orangeImgEEZ);
                if (!map.hasImage('red-marker-eez')) map.addImage('red-marker-eez', redImgEEZ);
                if (!map.hasImage('gray-marker-eez')) map.addImage('gray-marker-eez', grayImgEEZ);
                if (!map.hasImage('green-marker')) map.addImage('green-marker', greenImg);
                if (!map.hasImage('orange-marker')) map.addImage('orange-marker', orangeImg);
                if (!map.hasImage('red-marker')) map.addImage('red-marker', redImg);
                if (!map.hasImage('gray-marker')) map.addImage('gray-marker', grayImg);

                map.addLayer({
                  id: 'points',
                  type: 'symbol',
                  source: 'points',
                  layout: {
                    'icon-image': [
                      'case',
                      ['==', ['get', 'symbol'], 'HIGH_SEAS'],
                      [
                        'case',
                        ['<', ['get', 'timeDiff'], fourHoursThirtyMin],
                        'green-marker',
                        ['<', ['get', 'timeDiff'], sixHours],
                        'orange-marker',
                        ['<', ['get', 'timeDiff'], sevenDays],
                        'red-marker',
                        'gray-marker',
                      ],
                      [
                        'case',
                        ['<', ['get', 'timeDiff'], fourHoursThirtyMin],
                        'green-marker-eez',
                        ['<', ['get', 'timeDiff'], sixHours],
                        'orange-marker-eez',
                        ['<', ['get', 'timeDiff'], sevenDays],
                        'red-marker-eez',
                        'gray-marker-eez',
                      ],
                    ],
                    'icon-size': 1.0,
                    'icon-allow-overlap': true,
                    'icon-anchor': 'bottom',
                    'icon-rotate': ['get', 'bearing'],
                  },
                  paint: {
                    'icon-opacity': 0.7,
                  },
                });
              }
            })
            .catch((error) => console.error('Error loading SVG markers:', error))
            .finally(() => {
              [greenUrlEEZ, orangeUrlEEZ, redUrlEEZ, grayUrlEEZ, greenUrl, orangeUrl, redUrl, grayUrl].forEach(
                URL.revokeObjectURL
              );
            });
        };

        loadMarkerImages();
      } catch (error) {
        console.warn('Error adding map source or layer:', error);
      }

      let hoverPopup = null;

      map.on('click', 'points', (e) => {
        if (!isMounted.current) return;

        const feature = e.features[0];
        const props = feature.properties;

        // Store vessel name in local storage
        localStorage.setItem('selectedVessel', props.vesselNumber);

        // Call onMarkerClick if provided
        if (onMarkerClick && typeof onMarkerClick === 'function') {
          onMarkerClick({ coordinates: feature.geometry.coordinates, properties: props, feature });
        }

        // Navigate to /stocks after a slight delay
        setTimeout(() => {
          if (isMounted.current) {
            navigate('/stocks');
          }
        }, 0);
      });

      map.on('mouseenter', 'points', (e) => {
        if (!isMounted.current) return;

        map.getCanvas().style.cursor = 'pointer';
        const feature = e.features[0];
        const coordinates = feature.geometry.coordinates.slice();
        const props = feature.properties;
        const latDMS = toDMS(coordinates[1], true);
        const lngDMS = toDMS(coordinates[0], false);

        // Create a popup on hover
        hoverPopup = new mapboxgl.Popup({
          offset: 25,
          closeButton: false,
          closeOnClick: false,
        })
          .setLngLat(coordinates)
          .setHTML(
            `
              <div style="font-family: Arial, sans-serif; padding: 10px; background: #fff; max-width: 200px; border-radius: 5px;">
                <h3 style="margin: 0 0 5px; color: #333; font-size: 14px; font-weight: bold;">${props.vesselNumber}</h3>
                <p style="margin: 0; color: #555; font-size: 12px;"><strong>Location:</strong> ${latDMS}, ${lngDMS}</p>
              </div>
            `
          )
          .addTo(map);
      });

      map.on('mouseleave', 'points', () => {
        if (!isMounted.current) return;

        map.getCanvas().style.cursor = '';
        if (hoverPopup) {
          hoverPopup.remove();
          hoverPopup = null;
        }
      });
    };

    addMapFeatures();

    return () => {
      // Set isMounted to false to prevent actions after unmount
      isMounted.current = false;

      // Safely clean up event listeners and layers
      try {
        if (map?.off) {
          map.off('click', 'points');
          map.off('mouseenter', 'points');
          map.off('mouseleave', 'points');
        }
        if (map?.getLayer?.('points')) {
          map.removeLayer('points');
        }
        if (map?.getSource?.('points')) {
          map.removeSource('points');
        }
      } catch (error) {
        console.warn('Error during cleanup:', error);
      }
    };
  }, [map, positions, navigate, onMarkerClick]);

  return null; // No UI elements to render
}

export default MapPoints;